import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { removeUserFromBlacklistStart } from '../../../redux/blacklist/blacklist.actions';
import { ConfirmationModal } from '../../../components';
import { useModal } from '../../../hooks';
import useTranslation from 'hooks/useTranslation';

const mapState = ({ blacklistData }) => ({
  blacklist: blacklistData.blacklist,
});

const RemoveAllFromBlackList = ({ title }) => {
  const { blacklist } = useSelector(mapState);
  const dispatch = useDispatch();
  const [visible, toggle] = useModal();
  const { getTranslation } = useTranslation('BLACKLIST');
  const { t } = getTranslation();

  const isEmptyBlacklist = blacklist && blacklist.length === 0;

  const handleRemoveAllFromBlacklist = (event) => {
    if (event) event.preventDefault();
    dispatch(removeUserFromBlacklistStart({ removeAll: true }));
    toggle();
  };

  const openConfirmationModal = (event) => {
    if (event) event.preventDefault();
    toggle();
  };

  return (
    <div className='blacklist__header__actions'>
      {!isEmptyBlacklist && (
        <a
          href='#/'
          className='btn btn-primary'
          onClick={openConfirmationModal}
        >
          {title}
        </a>
      )}
      <ConfirmationModal
        message={t('REMOVE_ALL_CONFIRM_TEXT')}
        onConfirm={handleRemoveAllFromBlacklist}
        visible={visible}
        toggle={toggle}
      />
    </div>
  );
};

RemoveAllFromBlackList.propTypes = {
  title: PropTypes.string.isRequired,
};

export default RemoveAllFromBlackList;
